<template>
  <div class="table-height-button-wrapper">
    <base-button
      v-for="button in tableHeightButtons"
      :key="button.name"
      type="alternative"
      size="sm"
      class="tw:-translate-y-1/2 tw:shadow-md"
      :icon="button.icon"
      :tooltip="button.tooltip"
      @click="button.action"
    />
  </div>
</template>

<script>
import { sync } from 'vuex-pathify';

export default {
  name: 'TableHeightButtons',
  computed: {
    tableHeight: sync('table/tableHeight'),
    isIncreaseTableHeightButtonDisabled() {
      return this.tableHeight === 3;
    },
    isDecreaseTableHeightButtonDisabled() {
      return this.tableHeight === 0;
    },
    tableHeightButtons() {
      return [
        {
          name: 'increaseTableHeight',
          icon: 'mdi-chevron-up',
          disabled: this.isIncreaseTableHeightButtonDisabled,
          action: this.increaseTableHeightAction,
          tooltip: this.isIncreaseTableHeightButtonDisabled
            ? this.$i18n.t('button.increaseTableDisabled')
            : this.$i18n.t('button.increaseTable'),
        },
        {
          name: 'decreaseTableHeight',
          icon: 'mdi-chevron-down',
          action: this.decreaseTableHeightAction,
          disabled: this.isDecreaseTableHeightButtonDisabled,
          tooltip: this.isDecreaseTableHeightButtonDisabled
            ? this.$i18n.t('button.decreaseTableDisabled')
            : this.$i18n.t('button.decreaseTable'),
        },
      ];
    },
  },
  methods: {
    increaseTableHeightAction() {
      if (this.tableHeight < 3) {
        this.tableHeight++;
      }
    },
    decreaseTableHeightAction() {
      if (this.tableHeight > 0) {
        this.tableHeight--;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

body:has(.sider-menu__expanded):has(.legend__visible) .table-height-button-wrapper {
  width: calc(100dvw - #{$sidebar-width__expanded} - #{$sider-menu__expanded});
}
body:has(.sider-menu__expanded):has(.legend__hidden) .table-height-button-wrapper {
  width: calc(100dvw - #{$sidebar-width__collapsed} - #{$sider-menu__expanded});
}
body:has(.sider-menu__collapsed):has(.legend__visible) .table-height-button-wrapper {
  width: calc(100dvw - #{$sidebar-width__expanded} - #{$sider-menu__collapsed});
}
body:has(.sider-menu__collapsed):has(.legend__hidden) .table-height-button-wrapper {
  width: calc(100dvw - #{$sidebar-width__collapsed} - #{$sider-menu__collapsed});
}

.table-height-button-wrapper {
  height: 0;
  gap: 0.1rem;
  position: fixed;
  z-index: 4;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
</style>
